<template>
  <div class="component-body">
    <SubTitle text="Datos generales"/>
    <div class="card-section">
      <el-form :model="generalData"
               :rules="rules"
               class="form-mini"
               ref="GeneralDataForm">
        <el-form-item label="FECHA"
                      prop="date"
                      class="datePicker">
          <el-date-picker v-model="generalData.date"
                          size="mini"
                          :clearable="false"
                          format="dd-MM-yyyy"
                          placeholder="Ej: 22-12-2019"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="EMPRESA DE TRANSPORTE"
                      prop="enterprise">
          <el-select  v-model="generalData.enterprise"
                      value-key="id"
                      size="mini"
                      filterable
                      @change="getVehicles"
                      placeholder="Ej: TRANSPORTES GEOSORT">
            <el-option  v-for="enterprise in enterprises"
                        :key="enterprise.id"
                        :label="enterprise.name"
                        :value="{ id: enterprise.id, name: enterprise.name }"/>
          </el-select>
        </el-form-item>
        <el-form-item label="VEHÍCULO"
                      prop="patent">
          <el-select  v-model="generalData.patent"
                      value-key="id"
                      size="mini"
                      filterable
                      :disabled="vehicles.length < 1"
                      class="mini-loader"
                      v-loading="loadVehicles"
                      placeholder="Ej: GEO-55">
            <el-option  v-for="vehicle in vehicles"
                        :key="vehicle.id"
                        :label="vehicle.patent"
                        :value="{ id: vehicle.id, name: vehicle.patent }"/>
          </el-select>
        </el-form-item>
        <el-form-item label="CD (SIRVE COMO ORIGEN)"
                      prop="distributionCenter">
          <el-select  v-model="generalData.distributionCenter"
                      value-key="id"
                      size="mini"
                      filterable
                      placeholder="Ej: CD NOMBRE">
            <el-option  v-for="distributionCenter in distributionCenters"
                        :key="distributionCenter.id"
                        :label="distributionCenter.name"
                        :value="{ id: distributionCenter.id, name: distributionCenter.name }"/>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SubTitle from '../base/SubTitle.vue';
import { cachedAPIRequest } from '../../../mixins/cacheDim';

export default {
  name: 'GeneralData',
  components: {
    SubTitle,
  },
  data() {
    return {
      generalData: {
        date: '',
        patent: '',
        enterprise: '',
        transferCenter: '',
        distributionCenter: '',
      },
      rules: {
        patent: [{
          required: true,
          trigger: 'change',
          message: 'Seleccione un vehículo',
        }],
        enterprise: [{
          required: true,
          trigger: 'change',
          message: 'Seleccione una empresa',
        }],
        distributionCenter: [{
          required: true,
          trigger: 'change',
          message: 'Seleccione un CD',
        }],
        date: [{
          type: 'date',
          required: true,
          trigger: 'change',
          message: 'Seleccione una fecha',
        }],
      },
      vehicles: [],
      enterprises: [],
      transferCenters: [],
      distributionCenters: [],
      loadVehicles: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(Date.now() - 86400000);
        },
      },
    };
  },
  mounted() {
    moment.locale('es_CL');
    this.getEnterprises();
    this.getTransferCenters();
    this.getDistributionCenters();
  },
  methods: {
    validation() {
      this.$refs.GeneralDataForm.validate((valid) => {
        this.$emit('data', this.generalData, !valid);
        return valid;
      });
    },
    getEnterprises() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: { limit: 6000 },
      }).then((response) => {
        this.enterprises = response.data
          .sort((a, b) => (b.name > a.name ? -1 : 1));
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las empresas',
        });
      });
    },
    getDistributionCenters() {
      cachedAPIRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((response) => {
        this.distributionCenters = response.data
          .filter(dc => dc.id !== 8000)
          .sort((a, b) => (b.name > a.name ? -1 : 1));
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los CTT',
        });
      });
    },
    getTransferCenters() {
      cachedAPIRequest({
        module: 'planning',
        service: 'transfer_center',
        params: { limit: 1000 },
      }).then((response) => {
        this.transferCenters = response.data
          .sort((a, b) => (b.name > a.name ? -1 : 1));
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los CD',
        });
      });
    },
    getVehicles(enterprise) {
      this.loadVehicles = true;
      this.generalData.patent = null;
      cachedAPIRequest({
        module: 'planning',
        service: 'get_patents',
        pathparam: { id: enterprise.id },
        params: { limit: 1000 },
      }).then((response) => {
        this.loadVehicles = false;
        if (response.data.length > 0) {
          this.vehicles = response.data
            .sort((a, b) => (b.patent > a.patent ? -1 : 1));
        } else {
          this.$notify.warning({
            title: 'Advertencia',
            message: 'Empresa sin patentes activas',
          });
        }
      }).catch(() => {
        this.loadVehicles = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las patentes',
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-section {
    border-radius: 3px;
    border: 1px solid #E0E0E0;
    padding: 10px 10px 5px;
    .input {
      padding: 6px 5px;
      margin-bottom: 10px;
    }
  }
</style>
